let I18N = null

const setI18n = (i) => {
  I18N = i
}
const getI18n = (i) => {
  return I18N
}
const getI18nText = (k) => {
  return I18N.tc(k)
}
export default {
  setI18n,
  getI18n,
  getI18nText
}



// WEBPACK FOOTER //
// ./src/i18n/index.js